import { useContext } from "react";
import { ResourceContext } from "../../Service/Context/ResourceContext";
import { LoadingAnimation } from "../../Service/ResourceAdapter";

const AdditionalInfo = ({ inline }) => {
  const { profile, loading } = useContext(ResourceContext);

  if (loading) {
    return <LoadingAnimation />;
  }
  const isPropDefined = (prop) => prop && prop !== "";

  const styles = {
    listStyle: {
      display: inline ? "inline-flex" : "block",
      listStyleType: inline ? "none" : "none",
      marginBottom: 5,
      paddingLeft: 0,
      flexWrap: "wrap",
    },
    itemStyle: {
      marginRight: inline ? 20 : "unset",
      fontSize: 12,
      textAlign: "left",
    },
  };
  const {
    additionalInfo01,
    additionalInfo02,
    additionalInfo03
  } = profile;

  return (
    <ul style={styles.listStyle}>
      {isPropDefined(additionalInfo01) ? (
          <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
            {additionalInfo01}
          </li>
      ) : (
          <br />
      )}
      {isPropDefined(additionalInfo02) ? (
          <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
            {additionalInfo02}
          </li>
      ) : (
          <br />
      )}
      {isPropDefined(additionalInfo03) ? (
          <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
            {additionalInfo03}
          </li>
      ) : (
          <br />
      )}
    </ul>
  );
};

export default AdditionalInfo;
